import React, {Component} from 'react';
import './Signup.css';
import {Redirect} from "react-router-dom";

export default class Signup extends Component {
    state = {
        redirectBool: false,
        emailString: null,
        passwordString: null,
        visibilityBool: true,
        toggleButtonString: 'show',
        loaderBool: false,
        myName: null

    };

    componentDidMount() {
        document.title = 'Singup';
    }

    emailChange = (e) => {
        this.setState({emailString: e.target.value});
    };

    passwordChange = (e) => {
        this.setState({passwordString: e.target.value});
    };

    loginActivity = () => {
        if(this.state.myName && this.state.emailString && this.state.passwordString) {
            this.setState({loaderBool: true});
            fetch(`https://iotjokebase.herokuapp.com/registeruser?email=${this.state.emailString}&password=${this.state.passwordString}&myname=${this.state.myName}`, {method: 'POST'}).then(res => {
                res.json().then(resp => {
                    if (resp.userRegistered) {
                        alert(resp.name + ' registered');
                        this.setState({redirectBool: true});
                        this.setState({loaderBool: false});
                    } else {
                        alert('Email already exists');
                        this.setState({loaderBool: false});

                    }
                }).catch(err => {
                    console.log('JSON Error');
                    this.setState({loaderBool: false});
                });
            }).catch(err => {
                console.log('Error Fetching');
                this.setState({loaderBool: false});
            });
        } else{
            alert('Fields empty');
        }
    };

    redirectHome = () => {
        if (this.state.redirectBool) {
            return (<Redirect to='/'/>);
        }
    };

    toggleVisibility = () => {
        this.setState({visibilityBool: !this.state.visibilityBool});
        if (this.state.visibilityBool) {
            this.setState({toggleButtonString: 'hide'});
            document.getElementById('passId').type = 'text';
        } else {
            this.setState({toggleButtonString: 'show'});
            document.getElementById('passId').type = 'password';
        }
    };

    nameChange=(e)=>{
        this.setState({myName: e.target.value});
    };

    render() {
        return (<div>
            {this.redirectHome()}
            <div className='row'>
                <div className='col-md-4'> </div>

                <div className='col-md-4 col-md-2'>
                <form className="form-signin">
                    {/*<img className="mb-4" src="/docs/4.3/assets/brand/bootstrap-solid.svg" alt="" width="72" height="72">*/}
                    <h1 className="h3 mb-3 font-weight-normal">Please sign up</h1>

                    <div className="form-label-group">
                        <label htmlFor="inputName"></label>

                        <input type="text" className="form-control" onChange={this.nameChange} placeholder="Name" required
                               autoFocus/>
                    </div>

                    <div className="form-label-group">
                        <label htmlFor="inputEmail"></label>

                        <input type="email" id="inputEmail" className="form-control" onChange={this.emailChange} placeholder="Email address" required
                               autoFocus/>
                    </div>

                    <div className="form-label-group">
                        <label htmlFor="inputPassword"></label>
                        <input type="password" id="inputPassword" onChange={this.passwordChange} className="form-control" placeholder="Password" required/>

                    </div>
                    <button className="btn btn-lg btn-outline-primary" style={{'padding': '6px 6px','marginBottom':'20px','marginTop':'20px'}} type="button" onClick={this.loginActivity}>Sign
                        up
                    </button>
                </form>
                </div>
                <div className='col-md-4'> </div>

            </div>
        </div>);
    }
}
